import React, { Component } from 'react'

import Font from '../../../../../SPRINTA/atoms/Font'
import { Col, Row } from '../../../../../SPRINTA/atoms/Grid'
import Button from '../../../../../SPRINTA/atoms/Button'
import { Text, Select, FormGroup } from '../../../../../SPRINTA/atoms/Forms'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import Box from '../../../../../SPRINTA/atoms/Box'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import FontIcon from '../../../../../SPRINTA/atoms/FontIcon'

import * as user from '../../../../utils/user'
import style from './style.css'


// const banks = [
//   { 'code': '000', 'name': "Banco Volvo Brasil S.A."},
//   { 'code': '001', 'name': "Banco do Brasil S.A."},
//   { 'code': '003', 'name': "Banco da Amazônia S.A."},
//   { 'code': '004', 'name': "Banco do Nordeste do Brasil S.A."},
//   { 'code': '014', 'name': "Natixis Brasil S.A. Banco Múltiplo"},
//   { 'code': '017', 'name': "BNY Mellon Banco S.A."},
//   { 'code': '018', 'name': "Banco Tricury S.A."},
//   { 'code': '021', 'name': "BANESTES S.A. Banco do Estado do Espírito Santo"},
//   { 'code': '024', 'name': "Banco BANDEPE S.A."},
//   { 'code': '025', 'name': "Banco Alfa S.A."},
//   { 'code': '029', 'name': "Banco Itaú BMG Consignado S.A."},
//   { 'code': '033', 'name': "Banco Santander (Brasil) S.A."},
//   { 'code': '036', 'name': "Banco Bradesco BBI S.A."},
//   { 'code': '037', 'name': "Banco do Estado do Pará S.A."},
//   { 'code': '040', 'name': "Banco Cargill S.A."},
//   { 'code': '041', 'name': "Banco do Estado do Rio Grande do Sul S.A."},
//   { 'code': '047', 'name': "Banco do Estado de Sergipe S.A."},
//   { 'code': '062', 'name': "Hipercard Banco Múltiplo S.A."},
//   { 'code': '063', 'name': "Ibibank S.A. - Banco Múltiplo"},
//   { 'code': '064', 'name': "Goldman Sachs do Brasil Banco Múltiplo S.A."},
//   { 'code': '065', 'name': "Banco Patagon S.A."},
//   { 'code': '066', 'name': "Banco Morgan Stanley S.A."},
//   { 'code': '069', 'name': "BPN Brasil Banco Múltiplo S.A."},
//   { 'code': '070', 'name': "BRB - Banco de Brasília S.A."},
//   { 'code': '074', 'name': "Banco J. Safra S.A."},
//   { 'code': '075', 'name': "Banco CR2 S.A."},
//   { 'code': '076', 'name': "Banco KDB S.A."},
//   { 'code': '077', 'name': "Banco Intermedium S.A."},
//   { 'code': '079', 'name': "Banco Original do Agronegócio S.A."},
//   { 'code': '081', 'name': "BBN Banco Brasileiro de Negócios S.A."},
//   { 'code': '082', 'name': "Banco Topázio S.A."},
//   { 'code': '083', 'name': "Banco da China Brasil S.A."},
//   { 'code': '088', 'name': "Banco Randon S.A."},
//   { 'code': '094', 'name': "Banco Petra S.A."},
//   { 'code': '095', 'name': "Banco Confidence de Câmbio S.A."},
//   { 'code': '096', 'name': "Banco BM&amp;FBOVESPA de Serviços de Liquidação e Custódia S.A"},
//   { 'code': '104', 'name': "Caixa Econômica Federal"},
//   { 'code': '107', 'name': "Banco BBM S.A."},
//   { 'code': '119', 'name': "Banco Western Union do Brasil S.A."},
//   { 'code': '120', 'name': "Banco Rodobens S.A."},
//   { 'code': '121', 'name': "Banco Gerador S.A."},
//   { 'code': '122', 'name': "Banco Bradesco BERJ S.A."},
//   { 'code': '124', 'name': "Banco Woori Bank do Brasil S.A."},
//   { 'code': '184', 'name': "Banco Itaú BBA S.A."},
//   { 'code': '204', 'name': "Banco Bradesco Cartões S.A."},
//   { 'code': '208', 'name': "Banco BTG Pactual S.A."},
//   { 'code': '212', 'name': "Banco Original S.A."},
//   { 'code': '213', 'name': "Banco Arbi S.A."},
//   { 'code': '217', 'name': "Banco John Deere S.A."},
//   { 'code': '218', 'name': "Banco Bonsucesso S.A."},
//   { 'code': '222', 'name': "Banco Credit Agricole Brasil S.A."},
//   { 'code': '224', 'name': "Banco Fibra S.A."},
//   { 'code': '233', 'name': "Banco Cifra S.A."},
//   { 'code': '237', 'name': "Banco Bradesco S.A."},
//   { 'code': '241', 'name': "Banco Clássico S.A."},
//   { 'code': '243', 'name': "Banco Máxima S.A."},
//   { 'code': '246', 'name': "Banco ABC Brasil S.A."},
//   { 'code': '248', 'name': "Banco Boavista Interatlântico S.A."},
//   { 'code': '249', 'name': "Banco Investcred S.A."},
//   { 'code': '250', 'name': "BCV - Banco de Crédito e Varejo S.A."},
//   { 'code': '254', 'name': "Paraná Banco S.A."},
//   { 'code': '260', 'name': "Nu Pagamentos S.A (Nubank)" },
//   { 'code': '263', 'name': "Banco Cacique S.A."},
//   { 'code': '265', 'name': "Banco Fator S.A."},
//   { 'code': '266', 'name': "Banco Cédula S.A."},
//   { 'code': '300', 'name': "Banco de La Nacion Argentina"},
//   { 'code': '301', 'name': "Dock Instituição de Pagamento S.A"},
//   { 'code': '318', 'name': "Banco BMG S.A."},
//   { 'code': '320', 'name': "China Construction Bank (Brasil) Banco Múltiplo S.A."},
//   { 'code': '323', 'name': "Mercado Pago"},
//   { 'code': '336', 'name': "C6 Bank"},
//   { 'code': '341', 'name': "Itaú Unibanco S.A."},
//   { 'code': '346', 'name': "Banco Francês e Brasileiro S.A."},
//   { 'code': '370', 'name': "Banco Europeu para a America Latina (BEAL) S.A."},
//   { 'code': '376', 'name': "Banco J. P. Morgan S.A."},
//   { 'code': '389', 'name': "Banco Mercantil do Brasil S.A."},
//   { 'code': '394', 'name': "Banco Bradesco Financiamentos S.A."},
//   { 'code': '399', 'name': "HSBC Bank Brasil S.A. - Banco Múltiplo"},
//   { 'code': '403', 'name': "CORA SCD S.A."},
//   { 'code': '412', 'name': "Banco Capital S.A."},
//   { 'code': '422', 'name': "Banco Safra S.A."},
//   { 'code': '456', 'name': "Banco de Tokyo-Mitsubishi UFJ Brasil S.A."},
//   { 'code': '461', 'name': "Banco Asaas IPSA"},
//   { 'code': '464', 'name': "Banco Sumitomo Mitsui Brasileiro S.A."},
//   { 'code': '473', 'name': "Banco Financial Português S.A."},
//   { 'code': '477', 'name': "Citibank N.A."},
//   { 'code': '479', 'name': "Banco ItauBank S.A"},
//   { 'code': '487', 'name': "Deutsche Bank S.A. - Banco Alemão"},
//   { 'code': '488', 'name': "JPMorgan Chase Bank, National Association"},
//   { 'code': '492', 'name': "ING Bank N.V."},
//   { 'code': '494', 'name': "Banco de La Republica Oriental del Uruguay"},
//   { 'code': '495', 'name': "Banco de La Provincia de Buenos Aires"},
//   { 'code': '505', 'name': "Banco Credit Suisse (Brasil) S.A."},
//   { 'code': '600', 'name': "Banco Luso Brasileiro S.A."},
//   { 'code': '604', 'name': "Banco Industrial do Brasil S.A."},
//   { 'code': '610', 'name': "Banco VR S.A."},
//   { 'code': '611', 'name': "Banco Paulista S.A."},
//   { 'code': '612', 'name': "Banco Guanabara S.A."},
//   { 'code': '613', 'name': "Banco Pecúnia S.A."},
//   { 'code': '623', 'name': "Banco PAN S.A."},
//   { 'code': '626', 'name': "Banco Ficsa S.A."},
//   { 'code': '630', 'name': "Banco Intercap S.A."},
//   { 'code': '633', 'name': "Banco Rendimento S.A."},
//   { 'code': '634', 'name': "Banco Triângulo S.A."},
//   { 'code': '637', 'name': "Banco Sofisa S.A."},
//   { 'code': '641', 'name': "Banco Alvorada S.A."},
//   { 'code': '643', 'name': "Banco Pine S.A."},
//   { 'code': '653', 'name': "Banco Indusval S.A."},
//   { 'code': '654', 'name': "Banco A.J.Renner S.A."},
//   { 'code': '655', 'name': "Banco Votorantim S.A."},
//   { 'code': '707', 'name': "Banco Daycoval S.A."},
//   { 'code': '712', 'name': "Banco Ourinvest S.A."},
//   { 'code': '719', 'name': "Banif-Banco Internacional do Funchal (Brasil)S.A."},
//   { 'code': '735', 'name': "Banco Pottencial S.A."},
//   { 'code': '739', 'name': "Banco Cetelem S.A."},
//   { 'code': '740', 'name': "Banco Barclays S.A."},
//   { 'code': '741', 'name': "Banco Ribeirão Preto S.A."},
//   { 'code': '743', 'name': "Banco Semear S.A."},
//   { 'code': '745', 'name': "Banco Citibank S.A."},
//   { 'code': '746', 'name': "Banco Modal S.A."},
//   { 'code': '747', 'name': "Banco Rabobank International Brasil S.A."},
//   { 'code': '748', 'name': "Banco Cooperativo Sicredi S.A."},
//   { 'code': '751', 'name': "Scotiabank Brasil S.A. Banco Múltiplo"},
//   { 'code': '752', 'name': "Banco BNP Paribas Brasil S.A."},
//   { 'code': '753', 'name': "Novo Banco Continental S.A. - Banco Múltiplo"},
//   { 'code': '755', 'name': "Banco Merrill Lynch S.A."},
//   { 'code': '756', 'name': "Banco Cooperativo do Brasil S.A. - BANCOOB"},
//   { 'code': '757', 'name': "Banco KEB HANA do Brasil S.A."}
// ];


const banks = [
  { code: '001', name: 'Banco do Brasil' },
  { code: '033', name: 'Santander' },
  { code: '041', name: 'Banrisul' },
  { code: '077', name: 'Banco Inter' },
  { code: '104', name: 'Caixa Econômica Federal' },
  { code: '133', name: 'Cresol' },
  { code: '136', name: 'Unicred' },
  { code: '197', name: 'Stone' },
  { code: '208', name: 'BTG Pactual' },
  { code: '218', name: 'Banco BS2' },
  { code: '237', name: 'Bradesco' },
  { code: '260', name: 'Nubank' },
  { code: '290', name: 'PagBank' },
  { code: '323', name: 'Mercado Pago' },
  { code: '336', name: 'C6 Bank' },
  { code: '341', name: 'Itaú' },
  { code: '348', name: 'Banco XP' },
  { code: '364', name: 'Efí Bank' },
  { code: '380', name: 'PicPay' },
  { code: '403', name: 'Cora' },
  { code: '413', name: 'Banco BV' },
  { code: '422', name: 'Banco Safra' },
  { code: '461', name: 'Asaas' },
  { code: '623', name: 'Banco PAN' },
  { code: '707', name: 'Banco Daycoval' },
  { code: '735', name: 'Banco Neon' },
  { code: '748', name: 'Sicredi' },
  { code: '756', name: 'Sicoob' }
];


class ConfigData extends Component {

  state = {
    account: {
      account: '',
      agency: '',
      digit: '',
      document: '',
      holder: '',
      type: 'Conta Corrente',
      bankCode: ''
    },
    haveAccount: false,
    loading: true,
    saving: false,
    msgerror: null,
    msgsuccess: null,
  }

  componentWillMount() {
    user.getFinance()
    .then(data => {
      this.setState({
        loading: false,
        account: data.result ? data.result : this.state.account,
        haveAccount: data.result ? true : false
      })
    })
  }

  handleChange( target ) {
    let account = this.state.account
    account[target.name] = target.value
    this.setState({
      account
    })
  }

  setMsg(type, msg) {
    this.setState({
      [`msg${type}`]: msg
    })
    
    window.setTimeout(() => {
      this.setState({
        [`msg${type}`]: null
      })
    }, 3000)
  }

  handleSubmit(e) {
    e.preventDefault()

    let form = this.state.account

    if(
      form.account === '' ||
      form.agency === '' ||
      form.digit === '' ||
      form.document === '' ||
      form.holder === '' ||
      form.type === '' ||
      form.bankCode === ''
    ) {
      this.setMsg('error', 'Por favor, preencha todos os campos')
      return
    }
    
    this.setState({
      saving: true
    })

    user.saveFinance(form)
    .then(() => {
      this.setState({
        saving: false,
        haveAccount: true
      }, () => {
        this.setMsg('success', 'Dados alterados com sucesso')
      })
      
    })
  }

  render() {

    if(this.state.loading) {

      return (
        <div>
          <Placeholder type='retangle' style={{height: '40px', width: '40%'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
        </div>
      )
    }

    let bank = banks.find( bank => bank.code === this.state.account.bankCode)

    if(this.state.haveAccount)
      return (
        <Row>
          <Col>
            <Font heading='3' weight="100">Dados <b>Financeiros</b></Font>
          </Col>
          <Col>
            <Font>Aqui ficarão registradas suas contas bancárias autorizadas para faturamento de eventos criados por você e cobrança de inscrições.</Font>
          </Col>
          <Col>
            <Box style={{ margin: '20px 0' }}>
              <FontIcon name='bank' size={42} />
              <Font heading='3' weight='100' style={{marginTop: '20px'}}>{bank ? bank.name : `Banco: ${this.state.account.bankCode}`}</Font>
              <Font heading='4' weight='100'  style={{marginBottom: '20px'}}>{this.state.account.type}</Font>
              <div className={style.listDataBank}>
                <Row>
                  <Col size='12 4'>
                    <label>Agência:</label> {this.state.account.agency}
                  </Col>
                  <Col size='12 6'>
                    <label>Conta:</label> {this.state.account.account}-{this.state.account.digit}
                  </Col>
                  <Col size='12'> <hr /> </Col>
                  <Col size='12'>
                    <label>Titular:</label> {this.state.account.holder}
                  </Col>
                  <Col size='12' style={{marginTop: '30px'}}>
                    <label>Documento:</label> {this.state.account.document}
                  </Col>
                </Row>
              </div>
            </Box>
          </Col>

          <Col>
            <div className={style.alertMessage}>
              <Row>
                <Col size='1' text='center' style={{paddingTop: '5px'}}>
                  <Row>
                    <FontIcon name='alert' size={30} /> 
                  </Row>
                </Col>
                <Col size="8">
                  <Row>
                    <b>Atenção:</b> Para apagar um dos itens acima, é necessário entrar em contato conosco, <a href='http://sprinta.zendesk.com/hc'>clicando aqui</a>.         
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )
    else
    return (
      <form method='post' onSubmit={e => this.handleSubmit(e)}>
        <Row>
          <Col>
            <Font heading='3' weight="100" style={{marginBottom: '30px'}}>Adicionar <b>conta bancária</b></Font>
          </Col>

          <Col size='12 5'>
            <FormGroup spacer='large'>
              <Select label='Tipo de conta' name='type' handleChange={e => this.handleChange(e.target)} value={this.state.account.type}>
                <option value="Conta Corrente">Conta corrente</option>
                <option value="Poupança">Poupança</option>
              </Select>
            </FormGroup>
          </Col>

          <Col size='12 8'>
            <FormGroup spacer='large'>
              <Select label='Banco' name='bankCode' handleChange={e => this.handleChange(e.target)} value={this.state.account.bankCode}>
                <option>Selecione</option>
                {banks.map(bank => (
                  <option value={bank.code} key={bank.code}>{bank.name} - {bank.code}</option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          
          <Col>
            <Row>
              <Col size='12 4'>
                <FormGroup>
                  <Text label='Agência' name='agency' handleChange={e => this.handleChange(e.target)} value={this.state.account.agency} />
                </FormGroup>
              </Col>
              <Col size='12 4'>
                <FormGroup>
                  <Text label='Conta' name='account' handleChange={e => this.handleChange(e.target)} value={this.state.account.account} />
                </FormGroup>
              </Col>
              <Col size='12 4'>
                <FormGroup>
                  <Text label='Dígito verificador' name='digit' handleChange={e => this.handleChange(e.target)} value={this.state.account.digit} />
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col size='12 8'>
            <FormGroup>
              <Text label='Nome do titular da conta' name='holder' handleChange={e => this.handleChange(e.target)} value={this.state.account.holder} />
            </FormGroup>
          </Col>
          <Col size='12 8'>
            <FormGroup>
              <Text label='CPF ou CNPJ do titular' name='document' handleChange={e => this.handleChange(e.target)} value={this.state.account.document} />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col size='12 8' float='right' text='center left'>
              { this.state.msgerror && (
                <p style={{ color: 'red', fontSize: '14px', margin: '30px 0' }}> {this.state.msgerror} </p>
              ) }

              { this.state.msgsuccess && (
                <p style={{ color: 'green', fontSize: '14px', margin: '30px 0' }}> {this.state.msgsuccess} </p>
              ) }
          </Col>

          <Col size='12 4' float='left right' style={{ margin: '20px 0' }}>
            <Button theme='primary' disabled={this.state.saving}>
              {!this.state.saving ? `
                Adicionar conta
              ` : (
                <Loading color='#fff' size='30' />
              )}
            </Button>
          </Col>
        </Row>
      </form>
    )
  }

}

 export default ConfigData


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigFinance/index.js